import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@availity/element';

import { useAppContext } from '@/context';
import { checkNavigation, JOURNEY_USER_AGREEMENT } from '@/global';
import { useFRStep } from '@/hooks';
import { ErrorPage, UserAgreementPage } from '@/pages';

const UserAgreement = () => {
  const { queryParams = {} } = useAppContext();
  const [currentStep, setCurrentStep] = useState();

  const { authIndexValue = '' } = queryParams;

  // process authIndexValue in event that the UI should navigate to a different journey
  const journeyId = useMemo(() => authIndexValue?.toLowerCase(), [authIndexValue]);

  // call utility function to check if we need to navigate to a different route
  useEffect(() => {
    if (journeyId) {
      checkNavigation(journeyId);
    }
  }, [journeyId]);

  const { stepToRender = {} } = useFRStep(currentStep, JOURNEY_USER_AGREEMENT);

  const pageNodeToRender = useMemo(() => {
    let component;

    if (stepToRender) {
      const { payload = {} } = stepToRender;
      const { stage } = payload;

      switch (stage) {
        case 'Login-ShowTermsOfService': {
          component = <UserAgreementPage stepToRender={stepToRender} setCurrentStep={setCurrentStep} />;
          break;
        }
        case 'ErrorPage': {
          component = <ErrorPage key="errorPage" />;
          break;
        }
        default:
      }
    }

    return component;
  }, [stepToRender]);

  return <Box role="main">{pageNodeToRender}</Box>;
};

export default UserAgreement;
